import { Money, Quantity, VatRate } from '@garage/shared';

/**
 * Saisie des nombres décimaux : virgule française acceptée, convertie en point. Aucune conversion
 * en nombre flottant : la valeur reste une chaîne validée par le schéma partagé.
 */
export function normalizeDecimal(input: string): string {
  return input.replace(/\s/g, '').replace(',', '.');
}

export const isMoney = (v: string) => Money.safeParse(normalizeDecimal(v)).success;
export const isQuantity = (v: string) => Quantity.safeParse(normalizeDecimal(v)).success;
export const isVatRate = (v: string) => VatRate.safeParse(normalizeDecimal(v)).success;

/** Affichage d'une chaîne décimale avec la virgule française (quantité, taux). */
export function frDecimal(v: string): string {
  const trimmed = v.includes('.') ? v.replace(/0+$/, '').replace(/\.$/, '') : v;
  return trimmed.replace('.', ',');
}
